module.exports = __webpack_public_path__ + "static/media/playIcon.70e9e7df.svg";